<template>
  <div class="card mb-3 shadow-sm" style="min-width:260px; max-width:340px;">
    <div class="card-body">
      <h5 class="card-title mb-2">
        <i class="bi bi-cpu"></i> {{ device.name }}
      </h5>
      <div class="mb-1 small text-muted">ID: {{ device.shelly_id }}</div>
      <div class="mb-2">
        <span class="badge me-1" :class="isOnline ? 'bg-success' : 'bg-danger'">
          {{ isOnline === null ? "..." : isOnline ? "Online" : "Offline" }}
        </span>
        <span class="badge fs-6" :class="status === true ? 'bg-success' : status === false ? 'bg-secondary' : 'bg-warning'">
          {{ status === null ? "..." : status ? "ENCENDIDO" : "APAGADO" }}
        </span>
      </div>
      <div v-if="tempC !== null" class="mb-2">
        <small>
          <i class="bi bi-thermometer-half"></i>
          {{ tempC.toFixed(1) }}°C / {{ tempF.toFixed(1) }}°F
        </small>
      </div>
      <div class="btn-group w-100 mb-2" role="group">
        <button @click="turnOn" class="btn btn-success d-flex flex-column align-items-center" :disabled="loading || status === true || !isOnline">
          <i class="bi bi-toggle-on fs-4"></i>
          <small>Encender</small>
        </button>
        <button @click="turnOff" class="btn btn-danger d-flex flex-column align-items-center" :disabled="loading || status === false || !isOnline">
          <i class="bi bi-toggle-off fs-4"></i>
          <small>Apagar</small>
        </button>
        <button @click="getStatus" class="btn btn-outline-secondary d-flex flex-column align-items-center" :disabled="loading">
          <i class="bi bi-arrow-repeat fs-4"></i>
          <small>Actualizar</small>
        </button>
      </div>
      <div v-if="loading" class="text-center small mt-2">
        <i class="bi bi-arrow-clockwise bi-spin"></i> Consultando...
      </div>
      <div v-if="error" class="alert alert-danger py-1 px-2 small mt-2">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import api from "../api/api";
export default {
  props: ["device"],
  data() {
    return {
      status: null,
      isOnline: null,
      tempC: null,
      tempF: null,
      loading: false,
      error: null,
      refreshTimer: null, // <-- Para auto-refresh
    };
  },
  methods: {
    async turnOn() {
      this.loading = true;
      this.error = null;
      try {
        await api.deviceOn(this.device.id);
        await this.getStatus();
      } catch (e) {
        this.error = "Error al encender";
      }
      this.loading = false;
    },
    async turnOff() {
      this.loading = true;
      this.error = null;
      try {
        await api.deviceOff(this.device.id);
        await this.getStatus();
      } catch (e) {
        this.error = "Error al apagar";
      }
      this.loading = false;
    },
    async getStatus() {
      this.loading = true;
      this.error = null;
      try {
        let res = await api.deviceStatus(this.device.id);
        if (typeof res === "string") res = JSON.parse(res);

        // ESTA ES LA LÍNEA CLAVE:
        let d = res.data?.data ? res.data.data : res.data ? res.data : res;

        this.isOnline = d.online ?? null;
        if (
          d.device_status &&
          d.device_status["switch:0"] &&
          typeof d.device_status["switch:0"].output !== "undefined"
        ) {
          this.status = d.device_status["switch:0"].output;
          let temp = d.device_status["switch:0"].temperature;
          this.tempC = temp ? temp.tC : null;
          this.tempF = temp ? temp.tF : null;
        } else {
          this.status = null;
          this.tempC = null;
          this.tempF = null;
        }
      } catch (e) {
        this.status = null;
        this.isOnline = null;
        this.tempC = null;
        this.tempF = null;
        this.error = "Error al consultar estado";
      }
      this.loading = false;
    },
    startAutoRefresh() {
      // Refresca cada 8 segundos (ajusta el tiempo si quieres)
      this.refreshTimer = setInterval(() => {
        this.getStatus();
      }, 8000);
    },
    stopAutoRefresh() {
      if (this.refreshTimer) clearInterval(this.refreshTimer);
    }
  },
  mounted() {
    this.getStatus();
    this.startAutoRefresh();
  },
  beforeUnmount() { // Vue 2
    this.stopAutoRefresh();
  },
  // Si usas Vue 3, usa:
  // unmounted() { this.stopAutoRefresh(); }
};
</script>
